export { default } from './FundingInstructionCompleteTemplate';
